<template>
  <v-container>
    <v-row>
      <v-col v-for="(item,index) in getItems" :key="index" cols="12" md="4">
        <product-stock
            :product="item.product"
            :in-stock="item.quantity"
            :minimum="item.minimum"
            readonly
        ></product-stock>
      </v-col>
    </v-row>

  </v-container>

</template>

<script>
import ProductStock from "@/modules/delivery/components/ProductStock/ProductStock";

export default {
  name: "StockView",
  components: {ProductStock},
  props: {
    stock: Object,
  },
  data() {
    return {
      items: []
    }
  },

  computed:{
    getItems(){
      return this.stock.items.filter(i => i.hide === false)
    }
  },

}
</script>

<style scoped>

</style>
